import React from 'react';
import { Modal } from '../../components/ui';

// "Which number?" - a phone-book contact often holds several numbers (two SIMs,
// the office, the sons), so we ask instead of guessing the first one. Numbers
// that look like real mobiles are listed first; the rest are still offered
// because a landline is fine for a call-only guest.
export default function NumberChoiceDesktop({ vm }) {
  const { numberChoice, chooseContactNumber, cancelNumberChoice } = vm;
  if (!numberChoice) return null;
  const { contact, numbers } = numberChoice;
  const who = [contact.surname, contact.name].filter(Boolean).join(' ') || 'This contact';

  return (
    <Modal title={`Which number for ${who}?`} onClose={cancelNumberChoice}
      footer={<button className="btn light" onClick={cancelNumberChoice}>Cancel</button>}>
      <div className="muted" style={{ fontSize: 12.5, marginBottom: 10 }}>
        {numbers.length} numbers saved in the phone book — pick the one to invite.
      </div>
      <div className="num-choice">
        {numbers.map(n => (
          <button key={n.number} type="button" className="num-choice-row" onClick={() => chooseContactNumber(n.number)}>
            <strong>{n.number}</strong>
            <span className="muted">{n.label || (n.mobile ? 'Mobile' : 'Other')}</span>
          </button>
        ))}
      </div>
    </Modal>
  );
}
